import React from 'react';
import '../../css/home/PageBreak.css'; 

const PageBreak = () => {
  return (
    <div className="glow-divider"></div>
  );
};

export default PageBreak;